import { usePlosTranslations } from "../../../../../contexts/PlosTranslationsContext";
import { Sheet } from "../../../../Sheet";
import { broadcasterLink } from "../fixtureBroadcasters.css";
import Logo from "../Logo";
import { getBroadcasterKey } from "../utils";
import {
  broadcasterList,
  broadcasterListItem,
  broadcasterSheetHeader,
  broadcastersSheet,
} from "./multipleBroadcasters.css";
import { MultipleBroadcastersDialogProps } from "./types";

const MultipleBroadcastersDialog = ({
  broadcasters,
  open,
  handleClose,
}: MultipleBroadcastersDialogProps) => {
  const {
    fixtures: { broadcasters: broadcastersTitle },
    opensInNewTab,
  } = usePlosTranslations();
  return (
    <Sheet open={open} handleClose={handleClose}>
      <div className={broadcastersSheet}>
        <h2 className={broadcasterSheetHeader}>{broadcastersTitle}</h2>
        <ul className={broadcasterList}>
          {broadcasters.map((broadcaster) => (
            <li
              key={getBroadcasterKey(broadcaster)}
              className={broadcasterListItem}
            >
              <a
                href={broadcaster.link}
                className={broadcasterLink}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={opensInNewTab}
              >
                <Logo
                  abbreviation={broadcaster.abbreviation}
                  name={broadcaster.name}
                />
              </a>
            </li>
          ))}
        </ul>
      </div>
    </Sheet>
  );
};

export default MultipleBroadcastersDialog;
